import React, { type FC } from 'react';
import { DynamicField, Space, Text } from '@g2u/ui-kit';
import { Divider, FormInstance } from 'antd';
import { observer } from 'mobx-react-lite';

import { JsonData, JsonDataItem, type WithOptionalDataTest } from 'types';
import { BookingStore } from 'store';
import styles from '../location.module.scss';

export namespace ProductQuestion {
  export type Props = {
    selectedProduct: JsonDataItem;
    productList: JsonData;
    form: FormInstance;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { selectedProduct, productList, form } = props;
    const { serviceList, productSelection } = BookingStore;

    const selectedProductQuestions = serviceList?.product_child.filter((questionItem: JsonDataItem) =>
      questionItem.condition.value.includes(Number(selectedProduct.id)),
    );

    if (!selectedProductQuestions?.length) {
      return null;
    }

    return (
      <>
        <Space.$
          direction={Space.Direction.Vertical}
          size={Space.Size.Middle}
          className={styles.location__productQuestion}
        >
          <Space.$ direction={Space.Direction.Vertical} size={Space.Size.ExtraSmall}>
            <Text.$>
              Additional Questions for{' '}
              <i>&lsquo;{productList.find((item) => item.ID.toString() === selectedProduct.id)?.name}&rsquo;</i> :
            </Text.$>
          </Space.$>
          {selectedProductQuestions.map((question: JsonDataItem, i: number) => {
            if (question.type == 'script') return <Text.$ key={question.name}
                                                          mark >{question.label}</Text.$>;
            const fieldName = `extraQuestion-productId-${selectedProduct.id}-name-${question.name}`;
            const config = {
              ...question,
              label: `${question.label} :`,
              condition: undefined,
              initialValue: productSelection?.[fieldName],
              required: question.required,
              rules: [question.required ? { required: question.required } : undefined],
              name: fieldName,
            };
            return <DynamicField.$ key={i} form={form} fieldConfig={config} />;
          })}
        </Space.$>
        <Divider />
      </>
    );
  });
}
